import axios from "axios";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";

const useLogout = () => {
  const { setUser } = useAuth(); // لتحديث حالة المستخدم
  const navigate = useNavigate();

  const logout = async () => {
    try {
      // قراءة كلمة مرور API من متغير بيئة أو استخدام قيمة افتراضية
      const API_PASSWORD = process.env.REACT_APP_API_PASSWORD || "Project102$_";

      // استرجاع رمز التوثيق
      const authToken = localStorage.getItem("authToken");

      // إرسال طلب تسجيل الخروج إلى API مع api_password كـ query param
      const logoutUrl = `https://restocash.app/api/logout?api_password=${encodeURIComponent(
        API_PASSWORD
      )}`;
      await axios.post(
        logoutUrl,
        {},
        {
          headers: {
            ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
          },
        }
      );

      // حذف بيانات المستخدم من localStorage
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");

      // تحديث حالة المستخدم
      setUser(null);

      // توجيه المستخدم إلى صفحة تسجيل الدخول
      navigate("/login");
    } catch (err) {
      console.error(
        "خطأ أثناء تسجيل الخروج:",
        err.response?.data?.message || err.message
      );
    }
  };

  return logout; // إرجاع الدالة logout
};

export default useLogout;